import { useRouter } from 'next/router'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

/**
 * 目前是否在第三方內嵌頁（/embed/live/[roomId]）。
 *
 * 內嵌頁要的是「看起來就是直播間、但完全不能互動」，需要據此調整的元件（例如播放器的
 * 控制列、回放的進度條）直接問這個 hook，不必從頁面一層層往下傳 prop。
 *
 * 其他路由一律回 false，所以正式直播間的行為不會被影響——這點是結構上保證的，
 * 不依賴呼叫端有沒有小心處理。
 */
export const useIsEmbedRoute = () => useRouter().pathname === ROUTE_PATH.EMBED_LIVE_ROOM
